import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  CustomerTenderUnApprovalReasonBean,
  CustomerTenderUnApprovalReasonSearchCriteria,
  RestCustomerTenderUnApprovalReasonListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class CustomerTenderUnApprovalReasonListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate() {
    this.setInputFocus();

    //
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };

  saveCustomerTenderUnApprovalReason = (e) => {
    this.props.saveCustomerTenderUnApprovalReason(
      this.props.customerTenderUnApprovalReasonData
    );
  };
  deleteCustomerTenderUnApproval = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteCustomerTenderUnApproval(val, rowData);
  };
  editCustomerTenderUnApprovalReason = (e, rowdata) => {
    if (e.detail === 1) this.props.editCustomerTenderUnApprovalReason(rowdata);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms(e);
  };
  render() {
    let customerTenderUnApprovalReason_list =
      this.props.customerTenderUnApprovalReason_list;
    let customerTenderUnApprovalReasonData =
      this.props.customerTenderUnApprovalReasonData;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1.1">
              <FormLabel id="searchBarLabel">
                Customer Tender UnApproval Reason
              </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                type="text"
                name="code"
                onChange={this.props.onChange}
                value={customerTenderUnApprovalReasonData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                ref={this.listFormCodeRef}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {customerTenderUnApprovalReason_list != null ? (
              <tbody>
                {customerTenderUnApprovalReason_list.map((Info, index) => (
                  <tr key={index} data-item={Info}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editCustomerTenderUnApprovalReason(e, Info.code)
                        }
                      >
                        {Info.code}
                      </Button>
                    </td>
                    <td> {Info.description}</td>
                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>
                    {/* {Info.isApplied == false ? ( */}
                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.deleteCustomerTenderUnApproval(e, Info.code)
                        }
                      >
                        <DeleteIcon />
                      </Button>
                    </td> */}
                    {/* ) : (
                    <Button variant="secondry">
                      <CancelIcon />
                    </Button>
                  )} */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {customerTenderUnApprovalReason_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class CustomerTenderUnApprovalReasonEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();

    this.state = {
      showHide: this.props.showHide,
      customerTenderUnApprovalReasonData:
        this.props.customerTenderUnApprovalReasonData,
    };
  }

  componentDidMount() {
    this.codeRef.current.focus();
  }

  componentDidUpdate() {
    //
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }

  onChange = (e) => {
    this.props.onChange(e);
  };

  saveCustomerTenderUnApprovalReason = (e) => {
    this.props.saveCustomerTenderUnApprovalReason(
      this.state.customerTenderUnApprovalReasonData
    );
  };

  closeCustomerTenderUnApprovalReasonEntryForm() {
    this.props.closeCustomerTenderUnApprovalReasonEntryForm();
  }

  render() {
    let customerTenderUnApprovalReasonData =
      this.props.customerTenderUnApprovalReasonData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="2">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={customerTenderUnApprovalReasonData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter CustomerTenderUnApprovalReasonCode"
              onChange={this.onChange}
              value={customerTenderUnApprovalReasonData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              ref={this.codeRef}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={customerTenderUnApprovalReasonData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={customerTenderUnApprovalReasonData.isActive}
            />
          </Col>
        </Row>

        <br />
      </div>
    );
  }
}

class CustomerTenderUnApprovalReasonList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      customerTenderUnApprovalReason_list: [],
      response: {},
      pageTitle: "Customer Tender UnApproval Reason ",
      customerTenderUnApprovalReasonData:
        new CustomerTenderUnApprovalReasonBean(),
      pageList: new PageListBean(),
      criteria: new CustomerTenderUnApprovalReasonSearchCriteria(),
      companyCode: "",
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isCustomerTenderUnApprovalReasonListFormOpen: true,
      isCustomerTenderUnApprovalReasonEntryFormOpen: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPage(1);
    this.cleardata();
  }

  moduleCaption = "Customer Tender UnApproval Reason";

  cleardata = () => {
    let customerTenderUnApprovalReasonData =
      new CustomerTenderUnApprovalReasonBean();
    customerTenderUnApprovalReasonData.companyCode = this.companyCode;
    this.setState({
      customerTenderUnApprovalReasonData: customerTenderUnApprovalReasonData,
    });
  };
  opentypeforms = () => {
    let customerTenderUnApprovalReasonData =
      this.state.customerTenderUnApprovalReasonData;
    this.editCustomerTenderUnApprovalReason(
      customerTenderUnApprovalReasonData.code
    );
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  saveCustomerTenderUnApprovalReasonResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closeCustomerTenderUnApprovalReasonEntryForm();
      this.setState({ isShowCode: false });
    } else {
      this.handleresponse(response.data);
    }
  };

  saveCustomerTenderUnApprovalReason = (customerTenderUnApprovalReasonData) => {
    if (customerTenderUnApprovalReasonData.isFetched == true) {
      if (
        SecurityAccessManager.CustomerTenderUnapporveReasonMaintenanceEdit_IsAccessible()
      ) {
        MasterService.updateCustomerTenderUnApprovalReason(
          customerTenderUnApprovalReasonData,
          this.saveCustomerTenderUnApprovalReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Edit Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.CustomerTenderUnapporveReasonMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createCustomerTenderUnApprovalReason(
          customerTenderUnApprovalReasonData,
          this.saveCustomerTenderUnApprovalReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Create Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  editCustomerTenderUnApprovalReasonResponse = (response) => {
    if (response.data != null) {
      if (response.data.customerTenderUnApprovalReason != null) {
        let customerTenderUnApprovalReasonData =
          response.data.customerTenderUnApprovalReason;
        this.setState({
          customerTenderUnApprovalReasonData:
            customerTenderUnApprovalReasonData,
        });
        this.disable();
      }
    }
    this.openCustomerTenderUnApprovalReasonEntryForm();
  };
  editCustomerTenderUnApprovalReason = (customerTenderUnApprovalReasonCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerTenderUnApprovalReasonCode;
    if (
      SecurityAccessManager.CustomerTenderUnapporveReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.readCustomerTenderUnApprovalReason(
        readrestInput,
        this.editCustomerTenderUnApprovalReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let temp_customerTenderUnApprovalReasondata =
      this.state.customerTenderUnApprovalReasonData;
    temp_customerTenderUnApprovalReasondata[e.target.name] = e.target.value;
    this.setState({
      customerTenderUnApprovalReasonData:
        temp_customerTenderUnApprovalReasondata,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let customerTenderUnApprovalReasonData =
      this.state.customerTenderUnApprovalReasonData;
    customerTenderUnApprovalReasonData.companyCode = this.companyCode;
    customerTenderUnApprovalReasonData.code =
      this.state.customerTenderUnApprovalReasonData.code.toUpperCase();
    this.clearError();
    this.saveCustomerTenderUnApprovalReason(customerTenderUnApprovalReasonData);
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeCustomerTenderUnApprovalReasonEntryForm();
    this.componentDidMount();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openCustomerTenderUnApprovalReasonEntryForm = () => {
    this.setState({
      isCustomerTenderUnApprovalReasonListFormOpen: false,
      isCustomerTenderUnApprovalReasonEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,

      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeCustomerTenderUnApprovalReasonEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isCustomerTenderUnApprovalReasonListFormOpen: true,
      isCustomerTenderUnApprovalReasonEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
    this.loadPage(1);
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };
  loadCustomerTenderUnApprovalReasonResponse = (response) => {
    if (
      response.data != null &&
      response.data.customerTenderUnAppprovalReasonPageList != null
    ) {
      let customerTenderUnApprovalReasonList = new Array();
      if (
        !isEmptyArray(
          response.data.customerTenderUnAppprovalReasonPageList
            .customerTenderUnApprovalReason
        )
      ) {
        customerTenderUnApprovalReasonList =
          response.data.customerTenderUnAppprovalReasonPageList
            .customerTenderUnApprovalReason;
        customerTenderUnApprovalReasonList.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage =
        response.data.customerTenderUnAppprovalReasonPageList.currentPage;
      pageList.pageSize =
        response.data.customerTenderUnAppprovalReasonPageList.pageSize;
      pageList.totalCount =
        response.data.customerTenderUnAppprovalReasonPageList.totalCount;
      this.setState({
        customerTenderUnApprovalReason_list: customerTenderUnApprovalReasonList,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new CustomerTenderUnApprovalReasonSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadCustomerTenderUnApprovalReasonPage(pageInput, criteria);
  };
  loadCustomerTenderUnApprovalReasonPage = (pageList, searchCriteria) => {
    let criteria = new CustomerTenderUnApprovalReasonSearchCriteria();
    criteria = searchCriteria;
    let requestInput = new RestCustomerTenderUnApprovalReasonListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (
      SecurityAccessManager.CustomerTenderUnapporveReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.getCustomerTenderUnApprovalPageList(
        requestInput,
        this.loadCustomerTenderUnApprovalReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  deleteCustomerTenderUnApproval = (code, rowData) => {
    //
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.customerTenderUnApprovalReason_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ customerTenderUnApprovalReason_list: sorted });
    }
  };

  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isCustomerTenderUnApprovalReasonListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isCustomerTenderUnApprovalReasonListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isCustomerTenderUnApprovalReasonListFormOpen && (
          <CustomerTenderUnApprovalReasonListForm
            customerTenderUnApprovalReason_list={
              this.state.customerTenderUnApprovalReason_list
            }
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            opentypeforms={this.opentypeforms}
            customerTenderUnApprovalReasonData={
              this.state.customerTenderUnApprovalReasonData
            }
            editCustomerTenderUnApprovalReason={
              this.editCustomerTenderUnApprovalReason
            }
            deleteCustomerTenderUnApproval={this.deleteCustomerTenderUnApproval}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {!this.state.isCustomerTenderUnApprovalReasonListFormOpen && (
          <CustomerTenderUnApprovalReasonEntryForm
            customerTenderUnApprovalReasonData={
              this.state.customerTenderUnApprovalReasonData
            }
            closeCustomerTenderUnApprovalReasonEntryForm={
              this.closeCustomerTenderUnApprovalReasonEntryForm
            }
            saveCustomerTenderUnApprovalReason={
              this.saveCustomerTenderUnApprovalReason
            }
            editCustomerTenderUnApprovalReason={
              this.editCustomerTenderUnApprovalReason
            }
            onChange={this.onChange}
            isDisableFields={this.state.isDisableFields}
          />
        )}
      </div>
    );
  }
}

function CustomerTenderUnApprovalReasonAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <CustomerTenderUnApprovalReasonList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default CustomerTenderUnApprovalReasonAttributeModule;
